import * as rmd from 'material-ui';
import React, { Component } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { imageControl, imageDrag } from '../../../../widgets/components/interactive/topScorersMulti/actions';

const Label = styled.label`
    color: rgba(0, 0, 0, 0.3);
    font-size: 12px;
    display: block;
    margin-bottom: 10px;
`;

class MultipleBackgroundsPicker extends Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            multipleOptions: props[props.propKey] || {
                flipX: props.flipX,
                flipY: props.flipY,
                optimalScale: props.imgControl.optimalScale,
                currentScale: props.imgControl.currentScale,
                positionControl: { x: props.positionControl.x, y: props.positionControl.y },
                url: props.url,
            },
        };
    }

    componentWillMount() {
        const { propKey } = this.props;
        const { id } = this.props;

        this.props.imageControl({
            url: this.props[propKey] && this.props[propKey].url ? this.props[propKey].url : this.props.url,
            id,
        });
        window.addEventListener('WDPBgrManipulations', this.onManipulation, false);
    }

    onManipulation = e => {
        if (this.props.id !== e.detail.id) return;
        console.log('here', e.detail);
    };

    componentWillReceiveProps = nextProps => {
        if (
            nextProps.positionControl.x !== this.state.multipleOptions.positionControl.x ||
            nextProps.positionControl.y !== this.state.multipleOptions.positionControl.y
        ) {
            this.setState(
                ({ multipleOptions }) => ({
                    multipleOptions: {
                        ...multipleOptions,
                        positionControl: { x: nextProps.positionControl.x, y: nextProps.positionControl.y },
                    },
                }),
                () => {
                    this.props.onChange(this.props.propKey, this.state.multipleOptions);
                },
            );
        }

        if (nextProps.url !== this.state.multipleOptions.url) {
            this.setState(
                ({ multipleOptions }) => ({
                    multipleOptions: {
                        ...multipleOptions,
                        url: nextProps.url,
                        optimalScale: nextProps.imgControl.optimalScale,
                        currentScale: nextProps.imgControl.currentScale,
                    },
                }),
                () => {
                    this.props.onChange(this.props.propKey, this.state.multipleOptions);
                },
            );
        }
    };

    //for Checkbox
    onCheck = type => () => {
        const { id } = this.props;

        this.setState(
            ({ multipleOptions }) => ({
                multipleOptions: { ...multipleOptions, [`${type}`]: !multipleOptions[type] },
            }),
            () => {
                this.props.onChange(this.props.propKey, this.state.multipleOptions);
            },
        );

        this.props.imageControl({
            [type]: !this.props[type],
            id,
        });
    };

    //when change zoom
    handleSliderChange = (event, value) => {
        const { id } = this.props;
        const {
            multipleOptions: { optimalScale },
        } = this.state;

        if (value >= optimalScale) {
            this.setState(
                ({ multipleOptions }) => ({
                    multipleOptions: { ...multipleOptions, currentScale: value },
                }),
                () => {
                    this.props.onChange(this.props.propKey, this.state.multipleOptions);
                },
            );
        }

        this.props.imageControl({
            imgControl: { ...this.props.imgControl, currentScale: value },
            id,
        });
    };

    //when drag image
    handleControlledDrag = (e, position) => {
        const { id } = this.props;
        const { x, y } = position;

        //for stor
        this.props.imageDrag({
            positionControl: { x, y },
            id,
        });
    };

    //when end change zoom
    handleSliderDragStop = () => {
        const {
            multipleOptions: { currentScale, positionControl },
        } = this.state;
        const { areaControl, imgControl } = this.props;
        const maxXcoord = -(imgControl.width * currentScale - areaControl.width);
        const maxYcoord = -(imgControl.height * currentScale - areaControl.height);

        if (maxXcoord > positionControl.x || Math.floor(maxYcoord) > positionControl.y) {
            this.handleControlledDrag(null, { x: maxXcoord, y: maxYcoord / 2 });
        }
    };

    render() {
        const {
            multipleOptions: { currentScale },
        } = this.state;

        return (
            <div>
                <Label>{this.props.label}</Label>
                <rmd.Checkbox
                    checked={this.state.multipleOptions['flipX']}
                    label="Flip X"
                    onCheck={this.onCheck('flipX')}
                />
                <rmd.Checkbox
                    checked={this.state.multipleOptions['flipY']}
                    label="Flip Y"
                    onCheck={this.onCheck('flipY')}
                />
                <span style={{ padding: '30px 0 0', display: 'block' }}>Zoom</span>
                <rmd.Slider
                    min={1}
                    max={10}
                    step={0.01}
                    value={currentScale}
                    onChange={this.handleSliderChange}
                    onDragStop={this.handleSliderDragStop}
                    style={{ padding: '0 5px', boxSizing: 'border-box' }}
                />
            </div>
        );
    }
}

export default connect(
    (state, props) => {
        const { topScorersMultiBg } = state;

        return {
            areaControl: topScorersMultiBg.areaControl,
            imgControl: topScorersMultiBg.imgControl[props.id],
            positionControl: topScorersMultiBg.positionControl[props.id],
            flipX: topScorersMultiBg.flipX[props.id],
            flipY: topScorersMultiBg.flipY[props.id],
            url: topScorersMultiBg.url[props.id],
        };
    },
    { imageControl, imageDrag },
)(MultipleBackgroundsPicker);



/** WEBPACK FOOTER **
 ** ../src/dash/front/components/pickers/MultipleBackgroundsPicker.js
 **/